import HomeComponent from './Home';

export default HomeComponent;
